import styled from 'styled-components';

const StyledProductList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 36px;
  grid-auto-rows: minmax(100px, auto);
  @media (max-width: 500px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const StyledProductRow = styled.div`
  //height: 300px;
  //width: 300px;x
  //object-fit: cover;
  text-transform: uppercase;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  padding: 12px;
  transition: 0.3s ease-in-out;
  cursor: pointer;
  :hover {
    background-color: ${({theme}) => theme.color.hoverGray};
  }
`;

export {StyledProductList, StyledProductRow};

